<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-range-slider
          label="Výber obdobia"
          v-model="dateRange"
          step="1"
          :min="minYear"
          :max="maxYear"
          ticks="always"
          tick-size="4"
          thumb-label="always"
        ></v-range-slider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-slider
          v-model="linesZoom"
          color="orange"
          label="Mierka posunov"
          min="1"
          max="50"
          step="5"
          ticks="always"
          tick-size="4"
        ></v-slider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <l-map
          :zoom="zoom"
          :center="center"
          style="height: 600px; width: 100%; z-index: 0"
          ref="map"
          :bounds="bounds"
          @ready="setMapView"
          @update:zoom="zoomUpdated"
        >
          <l-tile-layer :url="url"></l-tile-layer>
          <l-control-scale
            position="topright"
            :imperial="false"
            :metric="true"
          ></l-control-scale>
          <!--
          <l-control position="topright">
            <v-img>
              <svg height="50" width="199">
                <text x="0" y="25" fill="red" font-size="smaller">100 mm</text>
                <polyline
                  points="0,0 0,10 199,10 199,0"
                  style="fill: transparent; stroke: red; stroke-width: 2"
                />
              </svg>
            </v-img>
          </l-control>
          -->
          <l-control position="bottomright">
            <v-img :src="require('../assets/nautical.svg')"></v-img>
          </l-control>
          <l-control position="bottomleft" v-if="isPublic">
            <v-img :src="require('../assets/logo_SGUDS_cb.svg')"></v-img>
          </l-control>
          <l-control-layers position="topright"></l-control-layers>
          <l-tile-layer
            v-for="tileProvider in tileProviders"
            :key="tileProvider.name"
            :name="tileProvider.name"
            :visible="tileProvider.visible"
            :url="tileProvider.url"
            :attribution="tileProvider.attribution"
            layer-type="base"
          />
          <template v-if="body.length > 0">
            <template v-for="(bod, i) in body">
              <l-circle-marker
                :key="`marker-${bod.ID}-${i}`"
                v-if="bod.Lat != 0 && bod.Lng != 0"
                :lat-lng="[bod.Lat, bod.Lng]"
                :radius="5"
              >
                <l-tooltip>{{ bod.ZNMB }}</l-tooltip>
              </l-circle-marker>
              <l-polyline
                :key="`polyline-${bod.ID}`"
                :ref="`polyline-${bod.ID}`"
                :lat-lngs="bod.posunyLatLngs"
                color="red"
                @ready="polylineReady(`polyline-${bod.ID}`)"
              ></l-polyline>
              <l-circle-marker
                v-for="(posun, posunI) in bod.Posuny"
                :key="`markerPosun-${bod.ID}-${posunI}`"
                :lat-lng="bod.posunyLatLngs[posunI]"
                :radius="2"
                :weight="1"
                color="red"
              >
                <l-tooltip :options="{ permanent: false, opacity: 0.7 }">
                  <div style="font-size: 7pt">
                    <b>{{ posunI + 1 }})</b>
                    {{ getPosunString(posun) }}
                  </div>
                </l-tooltip>
              </l-circle-marker>
            </template>
          </template>
        </l-map>
        <v-overlay :value="loading">
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-overlay>
      </v-col>
    </v-row>
    <v-row v-if="body.length > 0 && isPublicPage === false">
      <template v-for="bod in body">
        <v-col :key="bod.ID" cols="3">
          <v-select
            :items="bod.Hlbky"
            :label="`Hĺbka v bode ${bod.ZNMB}`"
            v-model="bod.SelectedHlbka"
            @change="changeHlbka(bod)"
          ></v-select>
        </v-col>
      </template>
    </v-row>
  </div>
</template>

<script>
//import * as L from "leaflet"
import {
  LMap,
  LControl,
  LControlScale,
  LControlLayers,
  LTileLayer,
  LCircleMarker,
  LPolyline,
  LTooltip
} from "vue2-leaflet"
import moment from "moment"
import "leaflet-arrowheads"

export default {
  components: {
    LMap,
    LControl,
    LControlScale,
    LControlLayers,
    LTileLayer,
    LCircleMarker,
    LPolyline,
    LTooltip
  },

  props: {
    lokalitaId: {
      type: Number,
      required: true
    },
    lokalitaMinYear: {
      type: Number,
      required: false,
      default: null
    },
    lokalitaMaxYear: {
      type: Number,
      required: false,
      default: null
    },
    posuny: {
      type: Array,
      required: true,
      default: function() {
        return []
      }
    }
  },

  data: () => ({
    loading: false,
    mapOptions: {
      zoomSnap: 0.5
    },
    bounds: [],
    posunyInkBodov: null,
    zoom: 8,
    center: [48.6, 19.7],
    url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",

    linesZoom: 1,
    scaledLatLngs: [],
    dateRange: [],
    tileProviders: [
      {
        name: "OpenTopoMap",
        visible: false,
        attribution:
          'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
      },
      {
        name: "FreeMapSk",
        visible: true,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, vizualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>',
        url: "https://{s}.freemap.sk/T/{z}/{x}/{y}.jpeg"
      },
      {
        name: "ZBGIS",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="https://zbgis.skgeodesy.sk/">ZBGIS</a>',
        url:
          "https://zbgis.skgeodesy.sk/zbgis/rest/services/ZBGIS/MapServer/tile/{z}/{y}/{x}"
      },
      {
        name: "OpenStreetMap",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      }
    ]
  }),

  computed: {
    isPublic: function() {
      let ret = false
      if (window.location.href.indexOf("public") > 0) {
        ret = true
      }
      return ret
    },
    body: function() {
      if (this.posunyInkBodov !== null) {
        return this.posunyInkBodov
      } else {
        return this.posuny //prvotne data sa posielaju ako properties
      }
    },
    isPublicPage: function() {
      if (this.lokalitaMinYear !== null) {
        return true
      }
      return false
    },
    minYear: function() {
      if (this.lokalitaMinYear !== null) {
        return this.lokalitaMinYear
      }
      let year = moment().year()
      if (this.body.length > 0) {
        for (let i = 0; i < this.body.length; i++) {
          const bod = this.body[i]
          year = Math.min(year, bod.MinRok)
        }
      }
      return year
    },
    maxYear: function() {
      if (this.lokalitaMaxYear !== null) {
        return this.lokalitaMaxYear
      }
      let year = 0
      if (this.body.length > 0) {
        for (let i = 0; i < this.body.length; i++) {
          const bod = this.body[i]
          year = Math.max(year, bod.MaxRok)
        }
      }
      if (year === 0) {
        year = moment().year() + 1
      }
      return year
    }
  },
  watch: {
    linesZoom: function() {
      this.recomputeLatLngs()
    },
    body: {
      deep: true,
      handler() {
        this.recomputeLatLngs()
      }
    },
    dateRange: function() {
      this.readPosunyInkBodov()
    }
  },

  methods: {
    getPosunString: function(aPosun) {
      let ret = ""
      //moment.locale("sk")
      ret = moment(aPosun.Datum, "MM.DD.YYYY").format("MMM YYYY")
      ret += " - " + aPosun.Dlzka.toFixed(2)
      return ret
    },
    recomputeLatLngs: function() {
      const magic = 0.00001 * this.linesZoom
      if (!this.$refs.map) {
        return []
      }
      for (let bi = 0; bi < this.body.length; bi++) {
        const bod = this.body[bi]
        if (bod.posunyLatLngs) {
          console.log("bod.posunyLatLngs.length:" + bod.posunyLatLngs.length)
        } else {
          console.log("bod nema este posunyLatLngs")
        }
        let posunyLatLngs = []
        //posunyLatLngs.push([bod.Lat, bod.Lng]) //start point
        for (let mi = 0; mi < bod.Posuny.length; mi++) {
          const posun = bod.Posuny[mi]
          posunyLatLngs.push([
            bod.Lat + posun.X * magic,
            bod.Lng + posun.Y * magic
          ])
        }
        bod.posunyLatLngs = posunyLatLngs
        bod.SelectedHlbka = bod.Hlbka
        bod.ID = bod.BodID
        console.log("bod.posunyLatLngs.length:" + bod.posunyLatLngs.length)
        this.$nextTick(() => {
          // eval(`this.$refs.polyline${bod.ID}.redraw()`)
        })
      }
    },

    setMapView: function() {
      /*
      this.$nextTick(() => {
        if (this.body.length > 0) {
          this.$refs.map.mapObject.setView(
            [this.body[0].Lat, this.body[0].Lng],
            12
          )
        }
      })
      */
    },

    zoomUpdated(zoom) {
      this.zoom = zoom
    },

    readPosunyInkBodov: async function() {
      this.loading = true
      try {
        let response = await this.$axios.get(
          `/lokalita/${this.lokalitaId}/posunyInkBodov?rokOd=${this.dateRange[0]}&rokDo=${this.dateRange[1]}`
        )
        if (response.status === 200) {
          this.posunyInkBodov = response.data.data
          this.recomputeLatLngs()
          this.setBounds()
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      } finally {
        this.loading = false
      }
    },
    changeHlbka: async function(bod) {
      try {
        console.log("changeHlbka", bod)
        let response = await this.$axios.post("/api/property", {
          code: "hlbka",
          key: bod.ID.toString(),
          value: bod.SelectedHlbka.toString()
        })
        if (response.status === 200) {
          console.log("Hlbka bodu saved")
          this.readPosunyInkBodov()
          this.setBounds()
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    setBounds: function() {
      console.log("Setting bounds 0")
      if (this.body.length === 0) {
        return
      }
      let latMin = this.body[0].Lat
      let latMax = this.body[0].Lat
      let lngMin = this.body[0].Lng
      let lngMax = this.body[0].Lng
      for (let i = 0; i < this.body; i++) {
        const bod = this.body[i]
        for (let j = 0; j < bod.posunyLatLngs; j++) {
          const posun = bod.posunyLatLngs[j]
          latMin = Math.min(latMin, posun[0])
          latMax = Math.max(latMax, posun[0])
          lngMin = Math.min(lngMin, posun[1])
          lngMax = Math.max(lngMax, posun[1])
        }
      }
      this.bounds = [
        [latMax, lngMin],
        [latMin, lngMax]
      ]
      console.log("Setting bounds to", this.bounds)
    },
    polylineReady: function(obj) {
      let refObj = this.$refs[obj]
      console.log("obj", obj)
      console.log("refObj", refObj)
      refObj[0].mapObject.arrowheads({
        size: "10px", //25%
        frequency: "endonly",
        proportionalToTotal: false,
        yawn: 60,
        fill: false
      })
    }
  },
  mounted: function() {
    this.dateRange = [this.minYear, this.maxYear]
  }
}
</script>
